<div class="tab-content">
	<div class="px-5 py-4">
		<form #saveSiteBatteryUtilizationSettings="ngForm" (ngSubmit)="saveBatteryUtilizationSettings()" [validate-form]="'batteries_utilization_settings'">
			<div class="tab-pane fade show active" id="battery_utilization">
				<div class="row mb-4" *ngFor="let field of fields">
					<label [for]="field.name" class="col-4 font-weight-bold">
						{{field.label}}
						<app-help-tooltip [field]="field.tooltip" [isSmall]="true" *ngIf="field.tooltip"></app-help-tooltip>
					</label>
					<div class="col-8 d-flex">
						<select
							*ngIf="field.options; else durationInput"
							class="form-control input-field"
							[name]="field.name"
							[id]="field.name"
							[(ngModel)]="brmSiteSettings[field.name]"
							(ngModelChange)="validateInputs()"
						>
							<option *ngFor="let option of field.options" [ngValue]="option">{{option}}</option>
						</select>

						<ng-template #durationInput>
							<input
								class="form-control input-field"
								type="number"
								min="0"
								[name]="field.name"
								[id]="field.name"
								[(ngModel)]="brmSiteSettings[field.name]"
								(input)="validateInputs()"
							>
						</ng-template>

						<span class="input-group-addon" *ngIf="fieldRanges[field.name]?.unit"><span>{{"g." + fieldRanges[field.name]?.unit | translate}}</span></span>
					</div>
				</div>
			</div>

			<div class="row my-4 align-items-center">
				<div class="col-md-4">
				</div>
				<div class="col-md-8">
					<div class="row align-items-center">
						<div class="col-md-8">
							<button type="submit" [disabled]="disableButton" class="btn text-white main-blue-bg btn-lg col-5 mr-4">{{'g.save' | translate}}</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
